<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="openAdd">新增方案</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #time="{ row }">
        <div>
          <div>开始{{ row.start_time }}</div>
          <div>结束{{ row.end_time }}</div>
        </div>
      </template>
      <template #payment="{ row }">
        <div>
          <el-tag v-if="row.payment" type="success">已支付</el-tag>
          <el-tag v-else type="info">待支付</el-tag>
        </div>
      </template>

      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="openExport(row)"
            >导入设备</el-button
          >
        </div>
      </template>
    </auto-table>

    <addOrEdit ref="editRef" @success="getList(1)"></addOrEdit>

    <exportDevice ref="exclRef"></exportDevice>
  </div>
</template>

<script>
import addOrEdit from "./addPlan.vue";
import exportDevice from "./exportDevice.vue";
export default {
  components: {
    addOrEdit,
    exportDevice,
  },
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "plan_name" },
        { name: "数量", value: "plan_count" },
        { name: "时间", value: "time", type: "custom" },
        { name: "支付", value: "payment", type: "custom" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      admin_id: "",
    };
  },

  mounted() {
    this.admin_id = this.$route.query.id;
  },
  methods: {
    openExport(row) {
      this.$refs.exclRef.open(row);
    },
    openAdd() {
      this.$refs.editRef.open();
    },
    init() {
      if (this.DataList.length == 0) {
        this.getList(1);
      }
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/deviceInvestPlan/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          admin_id: this.admin_id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>